import { gql } from "@apollo/client";

// TODO(LOOK-171944): fold the payout-basis fields into the shared payoutStatsHistory query once
// my-lenses-graphql-service serves them; until then useLensPlusEarnings falls back to it on error.
export const lensDetailsPayoutHistory = gql`
    query lensDetailsPayoutHistory($input: PayoutStatsInput!) {
        payoutStats(input: $input) {
            history {
                periods {
                    period
                    totalAmountMilliUsd
                    payoutSubscriberActionsUu
                    payoutLensSubscribeCount
                    payoutLensScore
                }
                cursor
            }
        }
    }
`;
